// extracted by mini-css-extract-plugin
export default {"container":"FreePlanRedeemSuccessPage_container__zb7EM","button":"FreePlanRedeemSuccessPage_button__DtqHA","buttonWord":"FreePlanRedeemSuccessPage_buttonWord__fqYZa"};